import React, { useState } from 'react';
import {
  CheckCircle2,
  XCircle,
  RefreshCw,
  Camera,
  Monitor,
  Layers,
  Eye,
  Film,
  Zap,
  Radio,
  ChevronDown,
  ChevronUp
} from 'lucide-react';

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// ReviewGate
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ReviewGate = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');

  const handleReject = () => {
    if (rejectReason.trim()) {
      onReject(rejectReason);
      setShowRejectModal(false);
      setRejectReason('');
    }
  };

  if (execution.status === 'approved') {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-green-700">
          <CheckCircle2 className="w-5 h-5" />
          <span className="font-medium">Execution approvata</span>
        </div>
      </div>
    );
  }

  if (execution.status === 'rejected') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-red-700">
          <XCircle className="w-5 h-5" />
          <span className="font-medium">Execution rigettata</span>
        </div>
        {execution.rejectionReason && (
          <p className="text-sm text-red-600 mt-2">{execution.rejectionReason}</p>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h3 className="font-medium text-gray-800 mb-3">Revisiona Output</h3>
        <div className="flex gap-3">
          <button onClick={() => onApprove()} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50">
            <CheckCircle2 className="w-4 h-4" /> Approva
          </button>
          <button onClick={onRegenerate} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50">
            <RefreshCw className="w-4 h-4" /> Rigenera
          </button>
          <button onClick={() => setShowRejectModal(true)} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50">
            <XCircle className="w-4 h-4" /> Rigetta
          </button>
        </div>
      </div>

      {showRejectModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h3 className="text-lg font-semibold mb-4">Motivo del Rigetto</h3>
            <textarea value={rejectReason} onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Spiega perchÃ© rigetti questa execution..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              rows={4} />
            <div className="flex gap-3 mt-4">
              <button onClick={() => setShowRejectModal(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                Annulla
              </button>
              <button onClick={handleReject} disabled={!rejectReason.trim()}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50">
                Conferma Rigetto
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// RenderingHeader â€” rendering mode, device, strategy
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const RenderingHeader = ({ rendering = {} }) => (
  <div className="bg-indigo-50 border border-indigo-200 rounded-lg p-4 space-y-3">
    {rendering.rendering_mode && (
      <div>
        <p className="text-xs font-medium text-indigo-500 uppercase tracking-wide mb-1">Rendering Mode</p>
        <p className="text-sm font-semibold text-indigo-800 leading-relaxed">{rendering.rendering_mode}</p>
      </div>
    )}
    {rendering.device_simulation && (
      <div>
        <p className="text-xs font-medium text-indigo-500 uppercase tracking-wide mb-1">Device Simulation</p>
        <p className="text-sm text-indigo-700 leading-relaxed">{rendering.device_simulation}</p>
      </div>
    )}
    {rendering.visual_realism_strategy && (
      <div>
        <p className="text-xs font-medium text-indigo-500 uppercase tracking-wide mb-1">Visual Realism Strategy</p>
        <p className="text-sm text-indigo-700 leading-relaxed">{rendering.visual_realism_strategy}</p>
      </div>
    )}
  </div>
);

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// RulesList â€” collapsible numbered list
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const RulesList = ({ icon: Icon, title, items = [], colorClass, bgClass, borderClass }) => {
  const [expanded, setExpanded] = useState(true);
  if (!items || !items.length) return null;

  return (
    <div className={`rounded-lg border ${borderClass} overflow-hidden`}>
      <button onClick={() => setExpanded(!expanded)}
        className={`w-full flex items-center justify-between p-3 ${bgClass} hover:opacity-90 transition-opacity`}>
        <div className="flex items-center gap-2">
          <Icon className={`w-4 h-4 ${colorClass}`} />
          <span className={`text-xs font-semibold uppercase tracking-wide ${colorClass}`}>{title}</span>
          <span className="ml-auto text-xs text-gray-400">{items.length} rules</span>
        </div>
        {expanded
          ? <ChevronUp className={`w-4 h-4 ${colorClass} opacity-50`} />
          : <ChevronDown className={`w-4 h-4 ${colorClass} opacity-50`} />}
      </button>
      {expanded && (
        <ul className="divide-y divide-gray-100 bg-white border-t border-gray-100">
          {items.map((item, i) => (
            <li key={i} className="flex items-start gap-3 p-3">
              <span className={`w-5 h-5 flex-shrink-0 flex items-center justify-center rounded-full text-xs font-bold ${colorClass} bg-gray-50 border border-current mt-0.5`}>
                {i + 1}
              </span>
              <p className="text-sm text-gray-700 leading-relaxed">{typeof item === "string" ? item : JSON.stringify(item)}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Contract15View â€” main component
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export default function Contract15View({ execution, onApprove, onReject, onRegenerate, loading }) {
  if (!execution) {
    return (
      <div className="flex items-center justify-center h-64 text-gray-400">
        <p>Nessuna execution selezionata</p>
      </div>
    );
  }

  const output = execution.output || execution.outputData || {};
  const rendering = output.native_ugc_rendering || {};

  return (
    <div className="h-full overflow-y-auto">
    <div className="space-y-4 max-w-4xl mx-auto p-6">

      {/* Header */}
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <div className="flex items-start justify-between">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">Contract 15 â€” Native UGC Rendering</h2>
            <p className="text-sm text-gray-500 mt-0.5">Visual Rendering Layer</p>
          </div>
          <div className="flex items-center gap-2">
            {execution.status === 'approved' && (
              <span className="flex items-center gap-1 text-xs font-medium text-green-700 bg-green-50 border border-green-200 rounded-full px-2.5 py-1">
                <CheckCircle2 className="w-3.5 h-3.5" /> Approvato
              </span>
            )}
            {execution.status === 'rejected' && (
              <span className="flex items-center gap-1 text-xs font-medium text-red-700 bg-red-50 border border-red-200 rounded-full px-2.5 py-1">
                <XCircle className="w-3.5 h-3.5" /> Rigettato
              </span>
            )}
            {execution.status === 'completed' && (
              <span className="flex items-center gap-1 text-xs font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-full px-2.5 py-1">
                <Monitor className="w-3.5 h-3.5" /> Completato
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Review gate */}
      <ReviewGate
        execution={execution}
        onApprove={onApprove}
        onReject={onReject}
        onRegenerate={onRegenerate}
        loading={loading}
      />

      {/* Rendering baseline */}
      {(rendering.rendering_mode || rendering.device_simulation || rendering.visual_realism_strategy) && (
        <RenderingHeader rendering={rendering} />
      )}

      {/* native_ugc_rendering sub-arrays */}
      <RulesList
        icon={Eye}
        title="Identity Preservation Rules"
        items={rendering.identity_preservation_rules}
        colorClass="text-purple-600"
        bgClass="bg-purple-50"
        borderClass="border-purple-200"
      />

      <RulesList
        icon={Film}
        title="Motion Capture Interpretation Rules"
        items={rendering.motion_capture_interpretation_rules}
        colorClass="text-violet-600"
        bgClass="bg-violet-50"
        borderClass="border-violet-200"
      />

      <RulesList
        icon={Layers}
        title="Environment Capture Rules"
        items={rendering.environment_capture_rules}
        colorClass="text-teal-600"
        bgClass="bg-teal-50"
        borderClass="border-teal-200"
      />

      <RulesList
        icon={CheckCircle2}
        title="UGC Plausibility Rules"
        items={rendering.ugc_plausibility_rules}
        colorClass="text-green-600"
        bgClass="bg-green-50"
        borderClass="border-green-200"
      />

      {/* Top-level arrays */}
      <RulesList
        icon={Monitor}
        title="Rendering Rules"
        items={output.rendering_rules}
        colorClass="text-indigo-600"
        bgClass="bg-indigo-50"
        borderClass="border-indigo-200"
      />

      <RulesList
        icon={Camera}
        title="Camera Behavior"
        items={output.camera_behavior}
        colorClass="text-blue-600"
        bgClass="bg-blue-50"
        borderClass="border-blue-200"
      />

      <RulesList
        icon={Radio}
        title="Compression Behavior"
        items={output.compression_behavior}
        colorClass="text-amber-600"
        bgClass="bg-amber-50"
        borderClass="border-amber-200"
      />

      <RulesList
        icon={Zap}
        title="Perceptual Artifacts"
        items={output.perceptual_artifacts}
        colorClass="text-orange-600"
        bgClass="bg-orange-50"
        borderClass="border-orange-200"
      />

    </div>
    </div>
  );
}

